import { useState, useEffect } from 'react';
import { FacetsData } from '../components/Facets';
import { SearchStateProps } from '../state/Context';

type FetchParams = {
  [key: string]: string | number | string[];
};

type EndpointResponse = {
  facets: FacetsData;
  resultsTotal: number;
  results: any[];
};

const useFetch = (
  endpoint: string,
  { query, page, sort, selectedFacets }: SearchStateProps
) => {
  const [data, setData] = useState<EndpointResponse>({
    facets: [],
    resultsTotal: 0,
    results: []
  });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      const params: FetchParams = {};
      setLoading(true);
      setError(false);

      if (query) {
        params.query = query;
      }

      if (page) {
        params.page = page;
      }

      if (sort) {
        params.sort = sort;
      }

      if (selectedFacets) {
        Object.keys(selectedFacets).forEach(key => {
          params[key] = selectedFacets[key];
        });
      }

      try {
        const result = await fetch(endpoint, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(params)
        });

        setData(await result.json());
      } catch (error) {
        setError(true);
      }

      setLoading(false);
    };

    fetchData();
  }, [endpoint, query, page, sort, selectedFacets]);

  return { data, loading, error };
};

export default useFetch;
